export default "__VITE_ASSET__4adb2d89__"